<template>
  <van-popup
      v-model:show="showFilterPopup"
      teleport="#app"
      closeable
      position="right">
    <div class="filter-popup">
      <div class="popup-content">
        <div class="vendor" v-if="vendorList.length > 0">
          <div class="title">供应商</div>
          <label
              v-for="(item,index) in vendorList"
              :key="index"
              :class="{selected: vendorCode.indexOf(item.code) !== -1 }"
              @click="selectVendor(item.code,item.name)">
            {{ item.name }} ({{ item.count }})
          </label>
        </div>
        <div class="year" v-if="yearList.length > 0">
          <div class="title">出版年</div>
          <div class="grid">
            <label
                v-for="(item,index) in yearList"
                :key="index"
                :class="{selected: yearCode.indexOf(item.code) !== -1 }"
                @click="selectYear(item.code)">
              {{ item.name }} ({{ item.count }})
            </label>
          </div>
          <div class="custom-year">
            <van-field
                v-model="yearStart"
                class="year-input"
                clearable
                input-align="center"
                placeholder="年"
                type="number"
                :disabled="yearCode.length>0"
            />
            <div class="line"></div>
            <van-field
                v-model="yearEnd"
                class="year-input"
                clearable
                input-align="center"
                placeholder="年"
                type="number"
                :disabled="yearCode.length>0"
            />
          </div>
        </div>
        <div class="publisher" v-if="publisherList.length > 0">
          <div class="title">出版社</div>
          <div class="grid">
            <label
                v-for="(item,index) in publisherList"
                :key="index"
                :class="{selected: publisherCode.indexOf(item.code) !== -1 }"
                @click="selectPublisher(item.code,item.name)">
              {{ item.name }} ({{ item.count }})
            </label>
          </div>
        </div>
      </div>
      <div class="btn-wrapper">
        <van-button type="default" size="large" block @click="resetClick">重置</van-button>
        <van-button type="primary" size="large" block @click="combineParams">确定</van-button>
      </div>
    </div>
  </van-popup>
</template>

<script setup>
import {computed, ref} from "vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  facetList: {
    type: Array,
    default: () => []
  }
});
const emit = defineEmits(['update:show', 'filterParams'])

const showFilterPopup = computed({
  get: () => {
    return props.show
  },
  set: (value) => {
    emit('update:show', value)
  }
});
const vendorList = computed(() => getFacetList('vendorId'));
const yearList = computed(() => getFacetList('publicationYear'));
const publisherList = computed(() => getFacetList('publisher'));
// 解析过滤条件
const getFacetList = (code) => {
  if (props.facetList) {
    const item = props.facetList.find(item => item.code === code);
    if (item) {
      return item.facetFields?.slice(0, 9) ?? [];
    }
  }
  return [];
}

const vendorCode = ref([]);
let vendorName = [];
const yearCode = ref([]);
const publisherCode = ref([]);
let publisherName = [];
const yearStart = ref('');
const yearEnd = ref('');

function handleSelect(arr, value) {
  const index = arr.indexOf(value)
  if (index !== -1) {
    arr.splice(index, 1);
  } else {
    arr.push(value);
  }
}

function selectVendor(code, name) {
  handleSelect(vendorCode.value, code);
  handleSelect(vendorName, name);
}

function selectYear(code) {
  handleSelect(yearCode.value, code);
}

function selectPublisher(code, name) {
  handleSelect(publisherCode.value, code);
  handleSelect(publisherName, name);
}

function resetClick() {
	reset();
	combineParams();
}
function reset() {
  vendorCode.value = [];
  yearCode.value = [];
  publisherCode.value = [];
  yearStart.value = '';
  yearEnd.value = '';
	vendorName = [];
	publisherName = [];
}

function combineParams() {
	if(yearStart.value && yearEnd.value && yearStart.value > yearEnd.value){
		const year = yearStart.value;
		yearStart.value = yearEnd.value;
		yearEnd.value = year;
	}
  // 请求参数
  let params = new URLSearchParams;
  // 显示过滤条件
  let showParams = [];
  if (vendorCode.value.length > 0) {
    params.append('filter_vendorId', vendorCode.value);
    showParams.push({name: '供应商', value: vendorName.join(), code: 'filter_vendorId'});
  }
  if (publisherCode.value.length > 0) {
    params.append('filter_publisher', publisherCode.value);
    showParams.push({name: '出版社', value: publisherName.join(), code: 'filter_publisher'});
  }
  if (yearCode.value.length > 0 && !yearStart.value && !yearEnd.value) {
    params.append('filter_publicationYear', yearCode.value);
    showParams.push({name: '出版年', value: yearCode.value.join(), code: 'filter_publicationYear'});
  }
  if (yearStart.value) {
    params.append('startPublicationYear', yearStart.value);
  }
  if (yearEnd.value) {
    params.append('endPublicationYear', yearEnd.value);
  }
  if (yearStart.value || yearEnd.value) {
    showParams.push({name: '出版年', value: yearStart.value + '-' + yearEnd.value, code: 'yearStartEnd'});
  }
  showFilterPopup.value = false;
  emit('filterParams', params, showParams);
}

defineExpose({
  reset
})
</script>

<style scoped lang="less">
@import "../../assets/css/filter-popup.less";
</style>
